import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Container from './components/Container';

function DeliveryTime({ minTime, maxTime, deliveryTime, className }) {
  if (!deliveryTime && (!minTime || !maxTime)) {
    return null;
  }

  return (
    <Container className={className}>
      {deliveryTime || `· ${minTime}-${maxTime} min`}
    </Container>
  );
}

DeliveryTime.propTypes = {
  minTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deliveryTime: PropTypes.string,
  className: PropTypes.string,
};

export default styled(DeliveryTime)``;
